<template>
  <div>
    <div class="w-full">
      <vx-card id="usersCard" ref="users" title="Guardians" v-show="!isUserListHidden">        
        <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" v-model="selected" pagination :max-items="pageSize" search :data="users" stripe ref="usersTable" class="vs-con-loading__container" single @selected="handleSelectedUser"> <!-- @sort="handleSort" -->
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            <!-- ADD NEW -->
            <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewUser">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Mobile Number</vs-th>
            <vs-th>Work Number</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>ID Number</vs-th>
            <vs-th>Children</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="user" :key="indextr" v-for="(user, indextr) in data" >

              <vs-td>
                {{ user.userFirstName + " " + user.userLastName }}
              </vs-td>

              <vs-td>
                {{ user.mobile }}
              </vs-td>

              <vs-td>
                {{ user.work }}
              </vs-td>

              <vs-td>
                {{ user.email }}
              </vs-td>

              <vs-td>
                {{ user.idNumber }}
              </vs-td>

              <vs-td>
                <vs-chip color="success">{{ user.childrenCount }}</vs-chip>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div>
      <vx-card id="userInfoCard" ref="userInfo" title="User Info" v-show="!isInfoHidden">
        <vs-divider class="mb-6 pt-0">General Information</vs-divider>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Email</label>
            <vs-input autocomplete="off" icon-no-border ref="emailInput" @blur="evaluateUser" onClick="this.select();" v-validate="'required|email'" name="email" class="w-full" icon-pack="feather" icon="icon-at-sign" v-model="formData.email" />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>First Name</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="First Name" icon-pack="feather" icon="icon-user" v-model="formData.userFirstName" />
            <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>
          </div>
        </div>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Last Name</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="Last Name" icon-pack="feather" icon="icon-user" v-model="formData.userLastName" />
            <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Work Phone</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'digits:10'" name="Work Phone" icon-pack="feather" icon="icon-phone" v-model="formData.work" />
            <span class="text-danger text-sm" v-show="errors.has('Work Phone')">{{ errors.first('Work Phone') }}</span>
          </div>
        </div>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Mobile</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|digits:10'" name="Mobile" icon-pack="feather" icon="icon-smartphone" v-model="formData.mobile" />
            <span class="text-danger text-sm" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Identification Number or Passport Number</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" name="Identification Number" icon-pack="feather" icon="icon-hash" v-model="formData.idNumber" />
          </div>
        </div>
        <div v-show="canChangePassword">
          <vs-divider class="mb-6 pt-0">Login Credentials</vs-divider>
          <div class="vx-row pb-3" v-show="!isChangePasswordHidden">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-checkbox v-model="changePassword">Change Password</vs-checkbox>
            </div>
          </div>
          <div class="vx-row pb-3" v-show="changePassword">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input style="display: none;"/>
              <label>Password</label>
              <div style="display: flex;">
                <vs-input id="passBox" autocomplete="off" icon-no-border onClick="this.select();" type="password" v-validate="'min:8|max:100'" name="password" ref="password" class="w-full" icon-pack="feather" icon="icon-lock" v-model="formData.password" />
                <feather-icon @mouseover="showPassword('passBox')" @mouseout="hidePassword('passBox')" icon="EyeIcon" class="cursor-pointer ml-3"></feather-icon>
              </div>
              <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
            </div>
          </div>
          <div class="vx-row pb-3" v-show="changePassword">
            <div class="vx-col sm:w-1/2 w-full mb-2" v-show="formData.password" >
              <label>Confirm Password</label>
              <div style="display: flex;">
                <vs-input id="confPassBox" autocomplete="off" icon-no-border onClick="this.select();" type="password" v-validate="'min:8|max:100|confirmed:password'" name="confirm_password" data-vv-as="password" class="w-full" icon-pack="feather" icon="icon-lock" v-model="formData.passwordConfirm" />
                <feather-icon @mouseover="showPassword('confPassBox')" @mouseout="hidePassword('confPassBox')" icon="EyeIcon" class="cursor-pointer ml-3"></feather-icon>
              </div>
              <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>
            </div>
          </div>
        </div>

        <div v-show="formData.id">
          <vs-divider id="students-divider">Students</vs-divider>

          <div class="vx-row mt-5">
            <div class="vx-col w-full">
                <vs-table :sst="true" @search="studentHandleSearch" @change-page="studentHandleChangePage" pagination :max-items="pageSize" search :data="allStudents" stripe ref="allStudentsTable" class="vs-con-loading__container" single>
                <div slot="header" class="flex flex-wrap-reverse flex-grow">
                  <div class="pl-3 flex items-baseline">
                    <h4>Assign an Existing Student</h4>
                    <h6 class="mx-4">OR</h6>
                    <vs-button color="success" type="filled" @click="addStudent">Add a NEW Student</vs-button>
                  </div>
                </div>
                <template slot="thead">
                  <vs-th sort-key="userFirstName">Name</vs-th>
                  <vs-th sort-key="mobile">Mobile Number</vs-th>
                  <vs-th sort-key="idNumber">ID Number</vs-th>
                  <vs-th sort-key="email">Email</vs-th>
                  <vs-th>Assign</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="student" :key="indextr" v-for="(student, indextr) in data">

                    <vs-td :data="data[indextr].userFirstName">
                      {{ student.userFirstName + " " + student.userLastName }}
                    </vs-td>

                    <vs-td :data="data[indextr].mobile">
                      {{ student.mobile }}
                    </vs-td>

                    <vs-td :data="data[indextr].idNumber">
                      {{ student.idNumber }}
                    </vs-td>

                    <vs-td :data="data[indextr].email">
                      {{ student.email }}
                    </vs-td>

                    <vs-td>
                      <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="linkChild(student.id)"></vs-button>
                    </vs-td>

                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>

          <div class="vx-row mt-5">
            <div class="vx-col w-full">
              <vs-table style="height: max-content;" ref="linkedChildrenTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="linkedChildren">
                <div slot="header" class="flex flex-wrap-reverse flex-grow">
                  <div class="pl-3 flex items-center">
                    <h4>Already Assigned</h4>
                  </div>
                </div>
                <template slot="thead">
                  <vs-th sort-key="userFirstName">Name</vs-th>
                  <vs-th sort-key="mobile">Mobile Number</vs-th>
                  <vs-th sort-key="idNumber">ID Number</vs-th>
                  <vs-th sort-key="email">Email</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="linkedChildren" :key="indextr" v-for="(student, indextr) in data">

                    <vs-td :data="data[indextr].userFirstName">
                      {{ student.userFirstName + " " + student.userLastName }}
                    </vs-td>

                    <vs-td :data="data[indextr].mobile">
                      {{ student.mobile }}
                    </vs-td>

                    <vs-td :data="data[indextr].idNumber">
                      {{ student.idNumber }}
                    </vs-td>

                    <vs-td :data="data[indextr].email">
                      {{ student.email }}
                    </vs-td>

                    <vs-td>
                      <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unlinkChild(student.id)"></vs-button>
                    </vs-td>

                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>

        <vs-divider class="mb-6 pt-0"></vs-divider>
        
        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveEditUser" ref="saveEditButton">Save</vs-button>
            <vs-button color="danger" class="mr-3 mb-2 vs-con-loading__container" v-if="formData.id" @click="deleteUserFromSite" ref="deleteUserButton">Delete</vs-button>
            <vs-button v-if="formData.id" color="warning" type="filled" class="ml-4" v-scroll-to="'#userInfoCard'" @click="cancelAdd">Close</vs-button>
            <vs-button v-else color="warning" type="border" class="mb-2" v-scroll-to="'#userInfoCard'" @click="cancelAdd">Cancel</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        pageSize: 10,
        loadingColor:'#fff',
        selected: [],
        isInfoHidden: true,
        isUserListHidden: false,
        isChangePasswordHidden: false,
        users: [],
        sites: [],
        formData: {
          id: 0,
          userFirstName: "",
          userLastName: "",
          mobile: "",
          work: "",
          email: "",
          password: "",
          passwordConfirm: "",
          isActive: false,
          idNumber: "",
          roles: []
        },
        changePassword: false,
        existingUser: [],
        mode: "",
        currentSite: "",
        canChangePassword: false,
        currentUser: {},
        isLoading: false,
        criteria: {
          pageSize: 0,
          pageNumber: 0,
          sortKey: "",
          sortOrder: "",
          searchPhrase: ""
        },
        studentsCriteria: {
          pageSize: 0,
          pageNumber: 0,
          sortKey: "",
          sortOrder: "",
          searchPhrase: ""
        },
        allStudents: [],
        linkedChildren: [],
      }
    },
    methods: {
      evaluateUser() {
        var self = this;
        if(this.mode == "Add User"){
          self.$validator.validate('email').then(result => {
            if (result) {
              var onSuccess = response => {
                self.existingUser = response.data;
                if (self.existingUser != null){
                  self.openConfirm();
                }
              };
              self.formData.email = self.formData.email.toLowerCase();
              
              self.$ajaxGet(self, "user/evaluateUser/" + self.formData.email, onSuccess);
            }
          });
        }
      },
      initValues() {
        this.formData.id = 0;
        this.formData.userFirstName = "";
        this.formData.userLastName = "";
        this.formData.mobile = "";
        this.formData.work = "";
        this.formData.email = "";
        this.formData.idNumber = "";
        this.formData.password = "";
        this.formData.passwordConfirm = "";
        this.formData.isActive = true;
        this.formData.roles.push({
          id: 17,
          text: "Guardian",
          isSelected: true,
          permissionText: "Guardian"
        });
        this.isLoading = false;
        this.mode = "";
        this.errors.clear();
        this.criteria.pageSize = this.pageSize;
        this.criteria.pageNumber = 1;
        this.criteria.sortKey = "";
        this.criteria.sortOrder = "";
        this.criteria.searchPhrase = "";
        this.studentsCriteria.pageSize = 10;
        this.studentsCriteria.pageNumber = 1;
        this.studentsCriteria.sortKey = "";
        this.studentsCriteria.sortOrder = "";
        this.studentsCriteria.searchPhrase = "";
        this.allStudents = [];
        this.linkedChildren = [];
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
        this.isUserListHidden = false;
        this.changePassword = false;
        this.loadUserData();
      },
      addNewUser() {
        this.initValues();
        this.canChangePassword = true;
        this.isChangePasswordHidden = true;
        this.isUserListHidden = true;
        this.isInfoHidden = false;
        this.mode = "Add User";
        this.changePassword = true;
      },
      showPassword(elementId) {
        document.getElementById(elementId).removeAttribute("type");
      },
      hidePassword(elementId) {
        document.getElementById(elementId).setAttribute("type", "password");
      },
      saveData() {
        this.loadUserData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      loadUserData(whenDone) {
        const self = this;
        self.showLoadingOnElement("usersTable", 1, "material");

        var onSuccess = function (response) {
          self.users.length = ((self.criteria.pageNumber - 1) * self.pageSize);

          if(self.criteria.pageNumber > 1) {
            for (let index = 0; index <= ((self.criteria.pageNumber - 1) * self.pageSize) - 1; index++) {
              self.users[index] = {};
            }
            self.users = self.users.concat(response.data.records);
          } else {
            self.users = response.data.records;
          }
          
          if(response.data.count > (self.criteria.pageNumber * self.pageSize))
            self.users[response.data.count - 1] = {};

          if (whenDone && typeof whenDone == "function")
            whenDone();
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.usersTable.$el);
        };

        self.$ajaxPost(self, "StudentGuardian/ListGuardians", self.criteria, onSuccess, onFinally);
      },
      getCurrentUser() {
        var self = this;
        var onSuccess = function (response) {
          self.currentUser = response.data;
        };
        self.$ajaxGet(self, "user/GetCurrentUserInfo", onSuccess);
      },
      handleSelectedUser(user) {
        this.mode = "Edit User";
        this.canChangePassword = this.currentUser.isSiteAdmin ? true : false;
        this.isChangePasswordHidden = false;
        this.isUserListHidden = true;
        this.isInfoHidden = false;
        this.changePassword = false;
        this.formData.id = user.id;
        if (this.formData.id) {
          this.getAllStudents();
          this.getLinkedChildren();
        }
        this.formData.userFirstName = user.userFirstName;
        this.formData.userLastName = user.userLastName;
        this.formData.mobile = user.mobile;
        this.formData.work = user.work;
        this.formData.email = user.email;
        this.formData.password = user.password;
        this.formData.passwordConfirm = user.password;
        this.formData.isActive = user.isActive;
        this.formData.idNumber = user.idNumber;
        this.formData.roles.push({
          id: 17,
          text: "Guardian",
          isSelected: true,
          permissionText: "Guardian"
        });
      },
      saveEditUser() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnElement("saveEditButton", 0.45, "material");
            self.formData.email = self.formData.email.toLowerCase();

            var onSuccess = response => {
              self.scrollToElement('students-divider');
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Guardian Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.saveEditButton.$el);
            };
            
            self.$ajaxPost(self, "user/addedituser", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      deleteUserFromSite(){
        var self = this;
        self.showLoadingOnElement("deleteUserButton", 0.45, "material");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "warning",
            text: "Guardian Removed",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });

          self.isInfoHidden = true;
          self.loadUserData();
          self.isUserListHidden = false;
        }
        var onFinally = response => {
          self.$vs.loading.close(self.$refs.deleteUserButton.$el);
        }

        self.$ajaxGet(self, `StudentGuardian/SetUserInactive/${self.formData.id}`, onSuccess, onFinally)
      },
      openConfirm() {
        var self = this;
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
          self.currentSite = JSON.parse(localStorage.getItem('userSiteInfo'))[0].name
        else
          self.currentSite = JSON.parse(localStorage.getItem('userSiteInfo')).name
        
        var sites = self.existingUser.sites.map((item) => {return item.name});
        self.$vs.dialog({
          acceptText: 'Cancel',
          color: 'warning',
          title: `Email Already Exists`,
          text: 'The email address (' + self.existingUser.email + ') seems to\nalready exist for \'' + self.existingUser.displayName + '\' at the following site(s):\n' + sites.join('\n') + '.' + '.',
          // text: 'The email address (' + self.existingUser.email + ') seems to\nalready exist for \'' + self.existingUser.displayName + '\' at the following site(s):\n' + sites.join('\n') + '.\n\nBy choosing \'Accept\', you\'ll allow \'' + self.existingUser.displayName + '\' to gain access to your current site: ' + self.currentSite + '.',
          // accept: self.acceptAlert
        })
      },
      acceptAlert() {
        const self = this;
        var user = {};
        this.showLoadingOnElement("userInfo", 1, "material");

        var onSuccess = function (response) {
          user = response.data;
          self.changePassword = false;
          self.formData.id = user.id;
          self.formData.userFirstName = user.userFirstName;
          self.formData.userLastName = user.userLastName;
          self.formData.mobile = user.mobile;
          self.formData.email = user.email;
          self.formData.password = user.password;
          self.formData.passwordConfirm = user.password;
          self.formData.isActive = user.isActive;
          self.formData.idNumber = user.idNumber;
          self.formData.site = JSON.parse(localStorage.getItem('userSiteInfo'))[0];
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.userInfo.$el);
        };

        self.$ajaxGet(self, "user/LinkExistingUserToNewSite/" + self.existingUser.userId, onSuccess, onFinally);
      },
      getAllStudents() {
        const self = this;
        self.showLoadingOnElement("allStudentsTable", 1, "corners");

        var onSuccess = function (response) {
          self.allStudents.length = ((self.studentsCriteria.pageNumber - 1) * self.pageSize);

          if(self.studentsCriteria.pageNumber > 1) {
            for (let index = 0; index <= ((self.studentsCriteria.pageNumber - 1) * self.pageSize) - 1; index++) {
              self.allStudents[index] = {};
            }
            self.allStudents = self.allStudents.concat(response.data.records);
          } else {
            self.allStudents = response.data.records;
          }
          
          if(response.data.count > (self.studentsCriteria.pageNumber * self.pageSize))
            self.allStudents[response.data.count - 1] = {};
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.allStudentsTable.$el);
        };

        self.$ajaxPost(self, `StudentGuardian/ListAllStudents/${self.formData.id}`, self.studentsCriteria, onSuccess, onFinally);
      },
      getLinkedChildren() {
        const self = this;
        self.showLoadingOnElement("linkedChildrenTable", 1, "corners");

        var onSuccess = function (response) {
          self.linkedChildren = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.linkedChildrenTable.$el);
        };

        self.$ajaxGet(self, `StudentGuardian/ListLinkedStudents?guardianId=${self.formData.id}`, onSuccess, onFinally);
      },
      linkChild(studentId) {
        var self = this;

        self.showLoadingOnElement("allStudentsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Student Linked to Guardian (${self.formData.userFirstName} ${self.formData.userLastName})`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-check'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.allStudentsTable.$el);
          self.getAllStudents();
          self.getLinkedChildren();
        };

        self.$ajaxGet(self, "StudentGuardian/LinkStudent?studentId=" + studentId + "&guardianId=" + self.formData.id, onSuccess, onFinally);
      },
      unlinkChild(studentId) {
        var self = this;
        self.showLoadingOnElement("linkedChildrenTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Student Unlinked from Guardian (${self.formData.userFirstName} ${self.formData.userLastName})`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-minus'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.linkedChildrenTable.$el);
          self.getAllStudents();
          self.getLinkedChildren();
        };

        self.$ajaxGet(self, "StudentGuardian/UnlinkStudent?studentId=" + studentId + "&guardianId=" + self.formData.id, onSuccess, onFinally);
      },
      addStudent() {
        var self = this;
        self.$router.push({ name: "StudentsList", query: {id: self.formData.id } });
      },
      handleSearch(searchPhrase) {
        var self = this;

        if(searchPhrase.length >= 3){
          self.criteria.searchPhrase = searchPhrase;

          self.loadUserData();
        }
        else if (searchPhrase == ""){
          self.criteria.searchPhrase = searchPhrase;
          self.loadUserData();
        }
      },
      handleChangePage(pageNumber) {
        var self = this;

        if(pageNumber > 0) {
          self.criteria.pageNumber = pageNumber;

          self.loadUserData();
        }
      },
      studentHandleSearch(searchPhrase) {
        var self = this;

        if(searchPhrase.length >= 3){
          self.studentsCriteria.searchPhrase = searchPhrase;

          self.getAllStudents();
        }
        else if (searchPhrase == ""){
          self.studentsCriteria.searchPhrase = searchPhrase;
          self.getAllStudents();
        }
      },
      studentHandleChangePage(pageNumber) {
        var self = this;

        if(pageNumber > 0) {
          self.studentsCriteria.pageNumber = pageNumber;

          self.getAllStudents();
        }
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToElement(elementId) {
        var scrollOptions = {
          easing: "ease-in-out",
          offset: -100,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById(elementId), 500, scrollOptions);
      },
    },
    mounted() {
      var self = this;
      self.showLoadingOnElement("usersTable", 1, "material");
      self.getCurrentUser();

      self.criteria.pageSize = self.pageSize;
      self.criteria.pageNumber = self.$refs.usersTable.currentPage;

      self.studentsCriteria.pageSize = self.pageSize;
      self.studentsCriteria.pageNumber = self.$refs.usersTable.currentPage;

      self.loadUserData(() => {
        if (self.$route.query.id) {
          var guardianToSelect = self.users.filter(function(_user) {
            return _user.id == self.$route.query.id 
          })[0];
          self.handleSelectedUser(guardianToSelect);
        }
      });
    },
  }

</script>
<style lang="scss">

</style>